module.exports = __webpack_public_path__ + "static/media/mail.716f6b76.svg";